import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-brand text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_work-space-hub/artifacts/grbksqgx_CC-logo_box_bronova_web.webp"
                alt="Coastal Collaborative"
                className="h-14 w-auto"
              />
            </Link>
            <p className="font-sans text-sm text-white/70 leading-relaxed">
              Brevard County's first and only coworking & shared office space. 
              Serving Satellite Beach, Indialantic, Melbourne Beach & Indian Harbour Beach.
              3,000 sqft of oceanview workspace designed for community.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg font-semibold mb-4">Our Space</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/offices" 
                  className="font-sans text-sm text-white/70 hover:text-sea transition-colors"
                  data-testid="footer-link-offices"
                >
                  Private Offices
                </Link>
              </li>
              <li>
                <Link 
                  to="/coworking" 
                  className="font-sans text-sm text-white/70 hover:text-sea transition-colors"
                  data-testid="footer-link-coworking"
                >
                  Coworking
                </Link>
              </li>
              <li>
                <Link 
                  to="/conference" 
                  className="font-sans text-sm text-white/70 hover:text-sea transition-colors"
                  data-testid="footer-link-conference"
                >
                  Conference Room
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="font-sans text-sm text-white/70 hover:text-sea transition-colors"
                  data-testid="footer-link-contact"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Amenities */}
          <div>
            <h4 className="font-serif text-lg font-semibold mb-4">Amenities</h4>
            <ul className="space-y-3 font-sans text-sm text-white/70">
              <li>Ocean View Workspace</li>
              <li>Super-Fast WiFi</li>
              <li>Gourmet Coffee & Kitchen</li>
              <li>65" TV Conference Room</li>
              <li>Restaurant On-Site</li>
              <li>Community Events</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-sea flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <span className="font-sans text-sm text-white/70">
                  1790 Highway A1A, Suite 209<br />
                  Satellite Beach, FL 32937
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-sea flex-shrink-0" strokeWidth={1.5} />
                <a 
                  href="tel:321-866-8572" 
                  className="font-sans text-sm text-white/70 hover:text-sea transition-colors"
                  data-testid="footer-phone"
                >
                  (321) 866-8572
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-sea flex-shrink-0" strokeWidth={1.5} />
                <a 
                  href="mailto:workcoastal@gmail.com" 
                  className="font-sans text-sm text-white/70 hover:text-sea transition-colors"
                  data-testid="footer-email"
                >
                  workcoastal@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="font-sans text-sm text-white/50">
              © {new Date().getFullYear()} Coastal Collaborative. All rights reserved.
            </p>
            <p className="font-sans text-sm text-white/50">
              Website Designed By{" "}
              <a 
                href="https://bp.agency" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sea hover:text-sea-light transition-colors"
                data-testid="footer-bp-link"
              >
                Brand Partners
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
